import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../authContext/authContext";
import { useTranslation } from "../../i18n/LanguageContext";

// Shown at /dashboard for an authenticated account that holds none of the
// recognized roles (admin/operator/patient/therapist) — shouldn't normally
// happen post-registration, but guards against a blank/crashing dashboard.
function NoAccessScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 3,
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        {t("portal.noAccess.title")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 420 }}>
        {t("portal.noAccess.subtitle")}
      </Typography>
      <Button variant="outlined" onClick={handleLogout}>
        {t("sidebar.account.logout")}
      </Button>
    </Box>
  );
}

export default NoAccessScreen;
